import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class ItemPointLinkQueryCriteriaClass extends BaseCriteriaModel {

  redeem_type?: Optional<string> = Optional.empty();
  reward_type?: Optional<string> = Optional.empty();
  applet_guid?: Optional<string> = Optional.empty();
  guid?: Optional<string> = Optional.empty();

  created_date: Optional<string> = Optional.empty();
  updated_date: Optional<string> = Optional.empty();
}

export class itemPointLinkCriteriaModelQuery {
  query = '';

  constructor(ItemPointLinkCriteriaModel: ItemPointLinkQueryCriteriaClass) {

    if (!ItemPointLinkCriteriaModel) {
      return;
    }

    this.query += ItemPointLinkCriteriaModel.redeem_type.filter(x => x !== '').map(x => '&redeem_type=' + x).orElse('');
    this.query += ItemPointLinkCriteriaModel.reward_type.filter(x => x !== '').map(x => '&reward_type=' + x).orElse('');
    this.query += ItemPointLinkCriteriaModel.applet_guid.filter(x => x !== '').map(x => '&app_id=' + x).orElse('');
    this.query += ItemPointLinkCriteriaModel.guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');

    this.query += '&status=' + ItemPointLinkCriteriaModel.status;
    this.query += '&orderBy=' + ItemPointLinkCriteriaModel.orderBy;
    this.query += '&order=' + ItemPointLinkCriteriaModel.order;
    this.query += '&offset=' + ItemPointLinkCriteriaModel.offset + '&limit=' + ItemPointLinkCriteriaModel.limit;
  }
}

